var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "" } },
    [
      _c(
        "el-upload",
        {
          attrs: {
            disabled: _vm.disabled,
            name: "image",
            drag: "",
            "before-upload": _vm.beforeUpload,
            action: _vm.$uploadUrl + _vm.urlUpload,
            "on-success": _vm.handleSuccess,
            "show-file-list": false,
            headers: { token: _vm.token, version: _vm.$version },
            "on-progress": _vm.onProgress,
            "on-error": _vm.onError,
          },
        },
        [
          !_vm.pathImage
            ? [
                _c("i", { staticClass: "el-icon-upload" }),
                _vm._v(" "),
                _c("div", { staticClass: "el-upload__text" }, [
                  _vm._v("\n        Kéo thả vào đây hoặc\n        "),
                  _c("em", [_vm._v("click vào để upload")]),
                ]),
              ]
            : _c("img", {
                staticClass: "avatar",
                attrs: { src: _vm.$url(_vm.pathImage), alt: "" },
              }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }